import { FlexRow } from "@quarks";
import { StyledSwiperHorizontal, StyledContainer, StyledExploreCellContainer } from "./styles";
import { forwardRef } from "react";
import { EmptyListPlaceholder, SwiperRefType } from "@molecules";
import { useTranslation } from "react-i18next";
import { Loader } from "@atoms";
import { ExploreState } from "src/components/pages/HereAndNow/useExploreState";
import { ExploreCell } from "./ExploreCell";
import Swiper from "swiper";
import { Resource } from "@lib/store";

/**
 * Lists (horizontally) available rooms in Here And Now
 */

export const HaNExploreListHorizontal = forwardRef<
  SwiperRefType,
  { exploreState: ExploreState; onClick: (resource: Resource) => void }
>(({ exploreState, onClick }, ref) => {
  const { t } = useTranslation();
  const { resourceData, highlightedResources, setSelectedResource } = exploreState;

  const resourcesAreLoading = resourceData?.status === "loading";

  const handleSlideChange = (swiper: Swiper) => {
    const visibleResource = highlightedResources[swiper.activeIndex];

    setSelectedResource(visibleResource ?? null);
  };

  return (
    <FlexRow
      columnGap={8}
      overflow="hidden"
      zIndex={2}
      justifyContent="center">
      {resourcesAreLoading ? (
        <StyledContainer justifyContent="center">
          <Loader />
        </StyledContainer>
      ) : highlightedResources.length ? (
        <StyledSwiperHorizontal
          freeMode={false}
          onSlideChange={handleSlideChange}
          ref={ref}
          centeredSlides={true}
          spaceBetween={16}>
          {highlightedResources.map((resource, index) => (
            <StyledExploreCellContainer key={resource.id}>
              <ExploreCell
                exploreState={exploreState}
                resource={highlightedResources[index]}
                onClick={onClick}
              />
            </StyledExploreCellContainer>
          ))}
        </StyledSwiperHorizontal>
      ) : (
        <EmptyListPlaceholder text={t("hereAndNow:NoSearchResults")} />
      )}
    </FlexRow>
  );
});
